
module.exports = function (app) {
  app.registerComponent('file-upload', '.js-file-upload', function (sb, el) {


    const fileInput = el.querySelector('[type="file"]');
    const elContainer = el.querySelector('.ginput_container_fileupload');


    const setFileName = (filename) => {

      // find old preview and remove it
      const currentPreview = el.querySelector('.ginput_preview_list');
      if (currentPreview) {
        currentPreview.remove();
      }

      let html = `<div class="ginput_preview"><strong>${filename}</strong></div>`;

      let element = document.createElement('div');
      element.className = 'ginput_preview_list';
      element.innerHTML = html;

      // const elPreviewList = el.querySelector('.ginput_preview_list');

      // if (elPreviewList) {
      //   elPreviewList.innerHTML = `<li>${filename}</li>`
      // }

      elContainer.appendChild(element) 

    }
    const onFileSelect = (ev) => {
      console.log(ev);

      if (fileInput.files.length > 0) {
        const fileName = fileInput.files[0].name;
        setFileName(fileName)
      } else {
        return;
      }
 
    }

    /* INIT ------------------------------------------- */
    return {
      init: function () {
  
    // detect if a file is selected
    fileInput.addEventListener('change', onFileSelect);

      },
      destroy: function () {
        fileInput.removeEventListener('change', onFileSelect);

  
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/file-upload.js